// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bwVe","label":"styles_label__2ZUm0"};